import { render, staticRenderFns } from "./Fenlei.vue?vue&type=template&id=ef3ad78c&"
import script from "./Fenlei.vue?vue&type=script&lang=js&"
export * from "./Fenlei.vue?vue&type=script&lang=js&"
import style0 from "./Fenlei.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports